import { Injectable, Injector } from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
// import {ToastrService} from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class HandleErrorService{
  constructor() {}
  public handleError(err:HttpErrorResponse){
    let errorMessage:string="";
    if(err.error instanceof ErrorEvent){
        errorMessage = `An error occured: ${err.error.message}`;
    }else{
   
        switch(err.status){
            case 400:
                errorMessage=`${err.status} : Bad request`;
                break;
            case 401:
                errorMessage=`${err.status} : Bad request`;
                break;
            case 500:
                errorMessage=`${err.status} : Internal Server Error`;
                break;
            case 503:
                errorMessage=`${err.status} : The requested service is not available`;
                break;
            case 0:
                errorMessage=`${err.status} : Unknown error`;
            break;
        }
        
    }
    //this.toastr.error(errorMessage);
 
    return errorMessage;
  }
}
